<template>
  <div class="sp-topbar">
    <div class="relative flex items-center justify-between h-full">
      <div class="topbar-left">
        <button
          class="flex items-center"
          :class="{
            'dark': route.path !== '/',
            'darken': top > (windowHt - 40)
          }"
          @click="router.push('/')"
        >
          <span>
            <img src="/assets/img/logo.png" alt="" />
          </span>
          <span class="flex items-center">
            <img src="/assets/img/sp.png" alt="" width="88" />
            <small>CAD/CAM</small>
          </span>
          <span v-if="route.path !== '/'" class="flex items-center gap-[5px] mr-[16px]">
            <SvgIcon name="call1" :size="16" />
            <span class="font-num">0577-88919606</span>
          </span>
          <span>Shenpusoft.</span>
        </button>

<!--        <nav>-->
<!--          <router-link to="/cad">{{t("topNav.cadLabel")}}</router-link>-->
<!--          &lt;!&ndash; <router-link to="">{{$t("topNav.cadLabel")}}</router-link> &ndash;&gt;-->
<!--          <router-link to="">{{t("topNav.fbjLabel")}}</router-link>-->
<!--          <router-link to="">{{t("topNav.cqjLabel")}}</router-link>-->
<!--          <button>0577-88919606</button>-->
<!--        </nav>-->
      </div>

      <div class="topbar-right">
<!--        <p>" 始于1992，匠心匠造信赖品牌</p>-->
<!--        <p><span class="inline-block w-[12px]"></span>畅销国内外 100+ 地区 "</p>-->

        <div class="lang-selection">
          <button
            :class="{'active' : locale === 'ZH'}"
            @click="switchLang('ZH')">中文</button>
          <button>/</button>
          <button
            :class="{'active' : locale === 'EN'}"
            @click="switchLang('EN')">En</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'

  const props = defineProps({
    scrollTop: {
      type: Number,
      default: 0
    }
  })

  const route = useRoute()
  const router = useRouter()
  const { t, locale } = useI18n()

  let windowHt = ref(0)
  let top = ref(0)

  watch(() => props.scrollTop, (val: number) => {
    console.log(val)
    console.log(windowHt)
    top.value = val

  })

  onMounted(() => {
    console.log(window.innerHeight)
    windowHt.value = window.innerHeight
  })

  function switchLang(lang: any) {
    locale.value = lang
  }

</script>

<style scoped lang="scss">
  .sp-topbar {
    .topbar-left {
      display: flex;
      align-items: center;

      & > button {
        position: relative;
        border-radius: 50px;
        height: 48px;
        //line-height: 48px;
        font-family: "Songti SC", sans-serif;
        font-size: 18px;
        font-weight: 600;
        color: #fff;
        //background-color: #042C9B;
        background-color: rgba(20, 58, 184, .4);
        user-select: none;
        transition: background-color .2s;

        &.darken {
          background-color: rgba(20, 58, 184, .9);
        }

        &.dark {
          background-color: rgba(0, 0, 0, .4);

          &.darken {
            background-color: rgba(0, 0, 0, .8);
          }
        }

        & > span {
          &:first-child {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            width: 48px;
            height: 100%;
            background-color: #0046E4;
            box-shadow: 0 4px 20px rgba(45, 30, 30, 0.15);

            img {
              width: 24px;
              object-fit: contain;
            }
          }

          &:nth-child(2) {
            padding: 0 16px 0 12px;

            small {
              margin-top: 2px;
              margin-left: 8px;
              font-size: 18px;
              //opacity: .55;
              color: #EF8D40;
            }
          }

          &:last-child {
            position: absolute;
            z-index: -1;
            right: -380px;
            font-size: 88px;
            opacity: .05;
          }
        }
      }

      nav {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-left: 50px;

        & > button,
        & > a {
          padding: 0 10px;
          //font-size: 14px;
          //font-weight: bold;
          opacity: .55;

          &:hover {
            font-weight: 600;
            color: #261204;
            background-color: #EF8D40;
            opacity: 1;
          }
        }
      }
    }

    .topbar-right {
      color: #fff;
    }
  }

  .lang-selection {
    display: inline-block;
    margin-left: 5px;
    vertical-align: 2px;

    & > button {
      font-size: 16px;
      font-weight: bold;
      color: #fff;
      opacity: .4;

      &:nth-child(2) {
        margin: 0 14px;
        font-size: 12px;
        vertical-align: 1px;
        cursor: default;
      }

      &:not(:nth-child(2)):hover,
      &.active {
        opacity: 1;
      }
    }
  }
</style>
